import React,  { useEffect, useState } from "react";
import axios from "axios";
import Correct from "../img/Primary.png";
import { Link } from "react-router-dom";
import { FaLongArrowAltRight } from "react-icons/fa";
import { url } from "../api/api";

// Add your crypto images


import Lofo from "../img/bitcoin.png";
import ethimg from "../img/eth.png";
import bnbimg from "../img/bnb.png";
import xrpimg from "../img/xrp.png";

const Plans = () => {
  const [investmentPlan, setinvestentPlan] = useState([]);

  const cryptoImages = {
    Bitcoin: Lofo,
    Ethereum: ethimg,
    BnB: bnbimg,
    Ripple: xrpimg,
  };

  const [cryptoRates, setCryptoRates] = useState({
    Bitcoin: { usd: null },
    Ethereum: { usd: null },
    BnB: { usd: null },
    Ripple: { usd: null },
  });

  // Fetch investment plans
  useEffect(() => {
    fetch(`${url}/investment/fetchallinvestmentmethod`)
      .then((response) => response.json())
      .then((data) => setinvestentPlan(data.data))
      .catch((error) => console.error("Error fetching investment plans:", error));
  }, []);

  // Fetch crypto prices
  useEffect(() => {
    const fetchCryptoRates = async () => {
      try {
        const response = await axios.get(
          "https://api.coingecko.com/api/v3/simple/price?ids=bitcoin,ethereum,binancecoin,ripple&vs_currencies=usd"
        );

        const updatedCryptoRates = {};
        const abbreviations = {
          bitcoin: "Bitcoin",
          ethereum: "Ethereum",
          binancecoin: "BnB",
          ripple: "Ripple",
        };

        Object.keys(response.data).forEach((crypto) => {
          const name = abbreviations[crypto];
          if (name) {
            updatedCryptoRates[name] = {
              usd: response.data[crypto].usd,
            };
          }
        });

        setCryptoRates(updatedCryptoRates);
      } catch (error) {
        console.error("Error fetching crypto rates:", error);
      }
    };

    fetchCryptoRates();
    const intervalId = setInterval(fetchCryptoRates, 60000);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div
      className="min-h-[1179px] w-full pb-20 md:pb-[50px]"
      style={{
        background:
          "radial-gradient(93.96% 223.34% at -10.76% 33.62%, #07031C 0%, #241D49 30.52%, #07031C 64.32%)",
      }}
    >
<div className="h-[50px]">


</div>
      
     <div className="flex justify-center md:mt-0 mt-[-200px] ">
  <div className="md:w-[1000px] w-[85%] h-[80px] grid items-center justify-items-center content-center overflow-hidden rounded-[30px] border border-[#D4F5F9]   shadow-lg border-opacity-85">
    <div className="flex md:gap-[100px] gap-[50px]  items-center justify-center animate-slide whitespace-nowrap px-4 py-4">
      {Object.keys(cryptoRates).map(
        (crypto) =>
          cryptoRates[crypto]?.usd && (
            <div
              key={crypto}
              className="flex items-center justify-center rounded-lg px-5 py-3 shadow-md min-w-[200px]"
            >
              <img
                src={cryptoImages[crypto]}
                alt={crypto}
                className="w-[30px] h-[30px] mr-3"
              />
              <div className="flex-1">
                <p className="text-sm font-bold mb-1 text-[#D4F5F9]">{crypto}</p>
                <p className="text-sm font-bold text-[#4AE115]">
                  ${cryptoRates[crypto].usd}
                </p>
              </div>
            </div>
          )
      )}
    </div>
  </div>
</div>

      <div className="flex flex-col md:flex-row justify-between">

        
        <div></div>
        <div className=" mt-20 md:mt-[20px] px-6 py-6 md:w-[50%]">
          <p className="text-[24px] md:text-[30px] font-normal text-white leading-snug font-lato">
            <span className="text-[#F2C493] font-semibold">grow</span> your Investment
            Portfolio with<br/> plans created with
            <span className="text-[#F2C493] font-semibold">YOU IN MIND</span>
          </p>
        </div>
      </div>


    

      {/* Investment Plans */}
<div className="grid grid-cols-1 md:grid-cols-3 w-[95%] content-center gap-20 md:gap-24 md:mt-14 m-[-20px]  mt-[20px] px-3 md:px-6 pb-6 md:pt-[100px] pt-[30px] bg-[#241D494D] border border-[#D4F5F9] md:rounded-[30px] rounded-[15px] border-opacity-80 md:max-w-[1150px] mx-auto">
  {investmentPlan &&
    investmentPlan.map((plan, index) => (
      <div
        key={plan._id}
        className="min-h-[400px] grid  place-items-center place-content-center  w-full md:px-4  md:py-6 transition hover:scale-105 duration-300 ease-in-out"
      >
        <div 
           className={`${index === 0 ? " shadow-md border-opacity-85 rounded-[30px]  px-8  py-6 md:border-0" : "border-0"}`}
           
        >
          <h2 className="text-[#F2C493] md:text-[16px]  text-[35px] font-bold uppercase tracking-wider font-lato">
            {plan.planname}
          </h2>
          <h2 className="text-white md:text-[20px]  text-[30px] mt-2 font-lato font-bold">
            ${plan.from} - ${plan.to} / {plan.duration} days
          </h2>
          <p className="text-[#F2C493] md:text-[12px] text-[18px] font-medium mt-4 font-lato">
            Short term investments, with market <br /> watch protection
          </p>

          <div className="mt-6 flex items-start gap-3">
            <img src={Correct} alt="" className="w-2 h-2 mt-1 font-lato" />
            <h3 className="text-white font-normal font-lato">
              Duration: {plan.duration} days
            </h3>
          </div>

          <div className="mt-4 flex items-start gap-3">
            <img src={Correct} alt="" className="w-2 h-2 mt-1" />
            <h3 className="text-white font-normal font-lato">
              ROI: {plan.roi}%
            </h3>
          </div>

          <div className="mt-4 flex items-start gap-3">
            <img src={Correct} alt="" className="w-2 h-2 mt-1" />
            <h3 className="text-white font-normal font-lato">
              Market watch protection
            </h3>
          </div>

          <Link
            to="/signup"
            className={`mt-10 inline-flex items-center border border-[#D4F5F9] w-full justify-between gap-4 h-[45px] rounded-lg px-6 font-semibold transition ${
              index === investmentPlan.length - 1
                ? "md:bg-[#D4F5F9] md:text-black text-[#D4F5F9]"
                : index === 0 ? "md:bg-transparent  bg-[#D4F5F9] border border-[#D4F5F9] text-[#D4F5F9] hover:bg-blue-900" : "border border-[#D4F5F9] text-[#D4F5F9] hover:bg-blue-900"
            }`}
          >
            <p className={`${index === investmentPlan.length - 1 ? "md:text-black text-[#D4F5F9]" : index  === 0 ? "md:text-[#D4F5F9] text-[#000]" :  "text-[#D4F5F9]"} font-lato`}>
              Get Started
            </p>
            <FaLongArrowAltRight
              size={24}
              className={`${index === investmentPlan.length - 1 ? "md:text-black text-[#D4F5F9]" : index  === 0 ? "md:text-[#D4F5F9] text-[#000]" :  "text-[#D4F5F9]"}`}
            />
          </Link>
        </div>
      </div>
    ))}
</div>





    </div>
  );
};

export default Plans;


